
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/limited-scope-representation-agreement",
      function () {
        return require("private-next-pages/limited-scope-representation-agreement.tsx");
      }
    ]);
  